import React from 'react';
import PropTypes from 'prop-types';
import ImageFigure from 'components/Models/ImageFigure/ImageFigure';
import cn from 'classnames';
import './NewImageBlock.scss';

const NewImageBlock = ({ image, inRichText, className }) => {
    {/* BE: Recommended width of the image in the content area is 2400px */}
    {/* BE: Recommended width of the image in the rich text block is 1560px */}
    return image ? (
        <div
            className={cn("new-image-block", {
                [className]: className,
                ["new-image-block_in-rich-text"]: inRichText
            })}
        >
            <figure className="new-image-block__container">
                <img src={image.url} alt={image.altText} className="new-image-block__image" />
                {(image.caption || image.photographer) && (
                    <figcaption className="new-image-block__caption">
                        {image.caption && <span className="new-image-block__caption-text">{image.caption}</span>}
                        {image.photographer && (
                            <span className="new-image-block__caption-photographer">{image.photographer}</span>
                        )}
                    </figcaption>
                )}
            </figure>
        </div>
    ) : null;
};

NewImageBlock.propTypes = {
    className: PropTypes.string,
    inRichText: PropTypes.bool,
    image: PropTypes.shape(ImageFigure.propTypes).isRequired,
};

export default NewImageBlock;


// WEBPACK FOOTER //
// ./src/components/NewImageBlock/NewImageBlock.jsx